<script setup lang="ts">
import { Link, usePage } from "@inertiajs/vue3"
import { computed } from "vue"

import { managerDashboardPath, rootPath } from "@/routes"
import type { Auth } from "@/types"

const page = usePage()

const homePath = computed(() => {
  const auth = page.props.auth as Auth | null
  return auth?.ui_mode === "manager" ? managerDashboardPath() : rootPath()
})
</script>
<template>
  <Link
    :href="homePath"
    class="bg-primary text-primary-foreground hover:bg-primary/90 mt-8 inline-flex items-center rounded-md px-4 py-2 text-sm font-medium shadow-sm focus:outline-none"
  >
    Volver al inicio
  </Link>
</template>
